
//     30.05.2015
//     Mehmet Ötkün
(function($, window, undefined) {

    'use strict';
    var _generateId = function() {
            return 'thy-' + Math.floor((Math.random() * 1000) + 1);
        },
        _getId = function(elm) {
            var id = elm.attr('id');
            if (!id) {
                var i = 0;
                while (!$('#' + id).lehgth && i < 10) {
                    id = _generateId();
                    i++;
                }
            }
            return id;
        },
        _scrollHandler = function(e) {
            e.preventDefault();
            e.stopPropagation();
            var that = $(this),
                content = that.data('href');
            if (!$(content).is(':visible')) {
                $(content).find('.content-skipper-link').trigger('click');
                return;
            }
            $(content).focus();
            $('html, body').animate({
                scrollTop: $(content).offset().top - 120
            }, 200);
        };

    var Accessibility = function(element, options) {
            this.$el = $(element);
            this._init(options);
        },
        _fixLinksFocus = function() {
            var links = $('a');
            links.each(function() {
                var link = $(this),
                    href = link.attr('href'),
                    tabindex = link.attr('tabindex');
                if (!href && !tabindex) {
                    var role = link.attr('role');
                    if(!role){
                        link.attr('role', 'button').attr('tabindex', 0);
                    }
                }
            });
        };
    Accessibility.defaults = {
        skipContentTemplate: '',
        titleAnchorTemplate: '<a class="title-anchor-link" href="#"><span class="fa fa-link"></span></a>',
        idPrefix: 'thy-'
    };

    Accessibility.prototype = {

        _init: function(options) {
            this.options = options = $.extend({}, Accessibility.defaults, options);
        },
        _labelFor: function(label, forEl) {
            if (!label.length || !forEl.length) {
                return;
            }
            var id = _getId(forEl);
            forEl.attr('id', id);
            label.attr('for', id);
        },
        fixTitle: function() {
            if (this.$el.find('.title-anchor-link').length || this.$el.hasClass('ignore-accessiable')) {
                return;
            }
            var id = _getId(this.$el);
            this.$el.attr('id', id);
            var link = $(this.options.titleAnchorTemplate);
            link.attr('data-href', '#' + id);
            this.$el.prepend(link);
        },
        skipTo: function(nextId) {
            var nextElem;
            if (this.$el.find('.content-skipper-link').length) {
                return;
            }
            nextId = nextId || this.$el.data('nextId');
            if (!nextId) {
                nextElem = this.$el.next();
                var id = _getId(nextElem);
                nextElem.attr('id', id).attr('role', 'main').attr('tabindex', -1);

            } else {
                nextElem = $('#' + nextId);
            }
            if (!nextElem.length) {
                return;
            }
            this.$el.addClass('skippable-container');
            var link = $(this.options.skipContentTemplate);
            link.attr('data-href', '#' + nextElem.attr('id'));
            if (this.$el[0].tagName.toLowerCase() == 'header')
                $('header > .navbar').prepend(link);
            else {
                this.$el.prepend(link);
            }
        },
        fixLabel: function(controlSelector, labelSelector) {
            controlSelector = controlSelector || '.tk-input-field';
            labelSelector = labelSelector || 'label';
            var that = this;
            var parents = this.$el.find(controlSelector);
            parents.each(function() {
                var parent = $(this),
                    control = $(parent.find('.form-control, button')[0]),
                    label = $(parent.find(labelSelector)[0]);
                that._labelFor(label, control);
            });
        }
    };
    // Accessibility PLUGIN DEFINITION
    // ========================

    function Plugin(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('Accessibility');
            var options = typeof option == 'object' && option;

            if (!data) $this.data('Accessibility', (data = new Accessibility(this, options)));
            if (typeof option === 'string' && ($.isFunction(data[option]) && option.charAt(0) !== "_")) {
                data[option]();
            }
        });
    }
    $.fn.accessibility = Plugin;
    $.fn.accessibility.Constructor = Accessibility;
    $(document).on('click', '.content-skipper-link', _scrollHandler);

    var checkCabinType = function(cntr) {
        cntr++;
        if ($('a.cabin-type').length > 0 && cntr < 40) {
            $('a.cabin-type').attr('tabindex', 0);
            $('a.cabin-type').children().attr('tabindex', -1);
            $('a.cabin-type').children().children().attr('tabindex', -1);
            $('a.cabin-type').keypress(function(event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    $(this).find('input').click();
                }
            });
        } else if(cntr < 50) {
            setTimeout(function() {
                checkCabinType(cntr);
            }, 400);
        }
    };
    var checkCabinAndFareSelectionTabs = function(cntr1) {

        cntr1++;
        if ($('.cabinandfareselectiontabs a').length > 0 && cntr1 < 50) {
            $('.cabinandfareselectiontabs a').attr('tabindex', 0);
            $('.cabinandfareselectiontabs a').children().attr('tabindex', -1);
            $('.cabinandfareselectiontabs a').children().children().attr('tabindex', -1);
            $('.tab-content .checkbox ').attr('tabindex', 0);
            $('.tab-content .checkbox ').children().attr('tabindex', -1);
            $('.tab-content .checkbox ').children().children().attr('tabindex', -1);
            $('.cabinandfareselectiontabs a').keypress(function(event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    $(this).click();
                    $('.cabinandfareselectiontabs a').children().children().attr('tabindex', -1);
                    $('.tab-content .checkbox ').attr('tabindex', 0);
                    $('.tab-content .checkbox ').children().attr('tabindex', -1);
                    $('.tab-content .checkbox ').children().children().attr('tabindex', -1);
                }
            });
            $('.tab-content .checkbox ').keypress(function(event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    $(this).find('input').click();
                }
            });
        } else if(cntr1 < 50){
            setTimeout(function() {
                checkCabinAndFareSelectionTabs(cntr1);
            }, 400);
        }
    };

    var checkWeeklyPricesChart = function(cntr3) {
        cntr3++;
        if ($('#weeklyPricesChart').length > 0 && cntr3 < 50) {
            $('#weeklyPricesChart .item').attr('tabindex', 0).keypress(function(event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    $(this).click();

                }
            });
        } else {
            setTimeout(function() {
                checkWeeklyPricesChart(cntr3);
            }, 400);
        }
    };

    checkCabinType(0);
    checkCabinAndFareSelectionTabs(0);
    checkWeeklyPricesChart(0);

    $(document).on('click', '#roundTripBookingDateSelection .flight-selection-triangle-position-fix a', function(event) {
        checkCabinAndFareSelectionTabs(0);
    });

    $(document).on('popupOpened', "#choosePerson", function(e) {
        setTimeout(function() {
            $('.ui-spinner-input').attr('tabindex', -1);
        }, 150);
        if ($('.ui-spinner-button[tabindex=-1]').length > 0) {
            $('.ui-spinner-button[tabindex=-1]').attr('tabindex', 0);
        }
    });

    var enterKeyBindToClickFn = function(elementQuery, callBack) {
        $(document).on('keydown', elementQuery, function(event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                callBack(event);
            }
        });
    };
    var tabKeyFn = function(elementQuery, callBack) {
        $(document).on('keydown', elementQuery, function(event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '9' && !event.shiftKey) {
                callBack(event);
            }
        });
    };
    var siftTabKeyBindToBackTabFn = function(elementQuery, callBack) {
        $(document).on('keydown', elementQuery, function(event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '9' && event.shiftKey) {
                callBack(event);
            }
        });
    };
    enterKeyBindToClickFn('.ui-spinner-button', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('.scroll-to-element.filter-edit-btn', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('.calculated-price-list a', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('#choosePerson .popup-wrapper-header a', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('.metro-checkbox >input[type="checkbox"]', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('.checkbox-container >input[type="checkbox"]', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('#flight-detail-tab .detail-button-div', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('.itinerary-details-btn', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('.itinerary-detail', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('.seatpicker-popovers', function(event) {
        $(event.target).click();
    });
    enterKeyBindToClickFn('.payment-table .table-schedule td', function(event) {
        $(event.target).click();
        setTimeout(function() {
            $('.payment-table  td .btn.btn-danger').focus();
        }, 100);
    });
    enterKeyBindToClickFn('#personCountBox', function(event) {
    	setTimeout(function() {
    		if($('#choosePerson').parent().find('.on').length>0){
    			$('#choosePerson').focus();
    		}
        }, 100);
    });
    siftTabKeyBindToBackTabFn('#msloginbanner-password', function(event) {
    	setTimeout(function() {
            $('#msloginbanner-username1').focus();
        }, 100);
    });
    enterKeyBindToClickFn('.ms-login-panel-slider', function(event) {
        $('#msSwitch').click();
        var msSwitchValue = document.getElementById("msSwitch");
		if(msSwitchValue.checked){
	        setTimeout(function() {
	        $('button[data-id="msloginbanner-logintype"]').focus();
	        },100);
		}
        
    });
    enterKeyBindToClickFn('.passengerDetailPanelCmp .metro-radio', function(event) {
        $(event.target).click();  $(event.target).click();
    });
    enterKeyBindToClickFn('#choosePerson a.showMore', function(event) {
        if (screen.width >= 768) {
            if (!$(event.target).is('.ui-icon')) {
                var isItToggle = $(event.target).attr("data-bind").includes('toggle');
                if (isItToggle) {
                    $(event.target).click();
                    setTimeout(function() {
                        $('.ui-spinner-button[tabindex=-1]').attr('tabindex', 0);
                        $('.ui-spinner-input').attr('tabindex', -1);
                    }, 150);
                    setTimeout(function() {
                        $('#choosePerson .pos-inherit a').first().focus();
                    }, 300);
                }
            }
        }
    });
    tabKeyFn('#choosePerson a:visible:last', function(event) {
        setTimeout(function() {
        	$('[href="#choosePerson"]').first().focus();

        }, 30);
    });
    tabKeyFn('.popover [tabindex="0"]:last', function(e) {
    	e.preventDefault();
    	$('.popover [tabindex="0"]').first().focus();
    });
    siftTabKeyBindToBackTabFn('.popover [tabindex="0"]:first', function(e) {
    	e.preventDefault();
    	$('.popover [tabindex="0"]').last().focus();
    });
    $(document).on('shown.bs.modal', $('.modal'), function(e) {
        $(this).accessibility('fixLabel');
        $('.metro-radio').attr('role', 'radio').attr('tabindex', 0);

    });

    var matrixEnterKeyBinding = function(counter) {
        setTimeout(function() {
            if ($(' .payment-table .table-schedule td').length > 0 && counter < 20) {
                $(' .payment-table .table-schedule td').attr('tabindex', 0);
            } else if(counter < 20 ) {
                counter++;
                matrixEnterKeyBinding(counter);
            }
        }, 500);
    };

    var contentReadyCounter = 0;
    $(document).on('contentReady', function() {
        contentReadyCounter++;

        $('section').addClass('skippable-container');
        var skippables = $('.skippable-container'),
            i = 0;
        skippables.each(function() {
            var cont = $(this);
            cont.attr('role', 'main').attr('tabindex', -1);
            cont.attr('id', _getId(cont));
            i++;
            if (i < skippables.length && !cont.data('nextId')) {
                var next = $(skippables[i]);
                var nextId = _getId(next);
                next.attr('id', nextId), cont.data('nextId', nextId);
            }
        });
        skippables.accessibility('skipTo');
        $('body').accessibility('fixLabel');


        _fixLinksFocus();
        if (contentReadyCounter == 1) {
            matrixEnterKeyBinding(0);
        }

        $('.ui-spinner-button[tabindex=-1]').attr('tabindex', 0);
        $('.ui-spinner-input').attr('tabindex', -1);
    });


    $(document).on('keydown', '[role="button"],[role="presentation"]', function(e) {
        var tabindex = $(e.target).attr('tabindex');
        if (tabindex === undefined) {
            tabindex = -1;
        }
        if (e.keyCode == 13 && tabindex > -1) {

            if ($(e.target).attr('data-bind')) {
                if ($(e.target).attr('data-bind').includes('click') || $(e.target).attr('id') == 'choosePerson_btn1') {
                    $(this).click();
                }
            }
        }
    });
})(jQuery, window);
define("jquery.accessibility", ["jquery"], function(){});
